import { useMemo, useState } from "react";
import {
  CountriesAndLanguages,
  countryStates,
} from "@/networking/addresses.api";
import { State, US_STATES, getRegionConfig } from "@/lib/country-config";

const EMPTY_COUNTRIES: CountriesAndLanguages["countries"] = [];
const EMPTY_STATES: State[] = [];

export default function useCountryStates(
  countries: CountriesAndLanguages["countries"] = EMPTY_COUNTRIES,
) {
  const [selectedCountry, setSelectedCountry] = useState<string>("US");

  const stateOptions = useMemo(() => {
    const translatedStates = countryStates(countries, selectedCountry);
    return (
      translatedStates ?? (selectedCountry === "US" ? US_STATES : EMPTY_STATES)
    );
  }, [countries, selectedCountry]);

  const handleCountryChange = (selectedCountryCode: string) => {
    setSelectedCountry(selectedCountryCode);
  };

  const config = getRegionConfig(selectedCountry);

  return { handleCountryChange, stateOptions, config, selectedCountry };
}
